import React, { useEffect, useState } from 'react';
import PlanetaryAlignmentCapture from '../components/PlanetaryAlignmentCapture/PlanetaryAlignmentCapture';

/**
 * Minimal page that renders the PlanetaryAlignmentCapture component
 * at exactly 1920x1080 with no scrollbars, padding, or chrome.
 * Designed purely for Puppeteer screenshot capture.
 * Shows an exit button for users who navigate here directly.
 */
const PlanetaryAlignmentCapturePage: React.FC = () => {
  const [isPuppeteer] = useState(() => {
    // Puppeteer sets specific user-agent or viewport; detect non-Puppeteer users
    return navigator.userAgent.includes('HeadlessChrome');
  });

  // Reset body/html styles to prevent white bleed in Puppeteer screenshots
  useEffect(() => {
    const bg = '#0a0a1e';
    document.documentElement.style.background = bg;
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.overflow = isPuppeteer ? 'hidden' : 'auto';
    document.body.style.background = bg;
  }, [isPuppeteer]);

  return (
    <div style={{ background: '#0a0a1e', minHeight: '100vh' }}>
      {!isPuppeteer && (
        <div style={{ padding: '12px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <a
            href="/"
            style={{
              color: '#FFD700', textDecoration: 'none', fontSize: 14,
              fontFamily: "'Inter', sans-serif", display: 'flex', alignItems: 'center', gap: 6,
            }}
          >
            &larr; Back to Pañcāṅgam
          </a>
        </div>
      )}
      <div
        style={{
          width: isPuppeteer ? 1440 : undefined,
          maxWidth: isPuppeteer ? undefined : '100%',
          height: isPuppeteer ? 1080 : undefined,
          margin: 0,
          padding: 0,
          overflow: isPuppeteer ? 'hidden' : undefined,
        }}
      >
        {/* Sampled at Ujjain sunrise, the instant the day's narrative describes (B-140). */}
        <PlanetaryAlignmentCapture fixedSize={isPuppeteer} lockToLocationSunrise />
      </div>
    </div>
  );
};

export default PlanetaryAlignmentCapturePage;
